import cx from 'classnames';

import { Icon, SettingsGroupItem } from '@sb/design-system';

interface RestoreAlertProps {
  /** 'critical' is reserved for things that stop the restore happening at
   *  all; everything else the operator is merely being warned about. */
  severity?: 'warning' | 'critical';
  children: React.ReactNode;
  'data-testid': string;
}

/** The one alert shape this modal uses, following the software-update
 *  screen's warning row: outlined rather than filled, so a paragraph of
 *  explanation stays readable. */
export function RestoreAlert({
  severity = 'warning',
  children,
  'data-testid': dataTestId,
}: RestoreAlertProps) {
  const isCritical = severity === 'critical';

  return (
    <SettingsGroupItem
      isSeparated
      data-testid={dataTestId}
      className={cx(
        'tw-bg-transparent',
        'tw-border',
        'tw-border-divider-primary',
        'tw-text-13',
        'tw-py-8',
        'tw-whitespace-normal',
        'tw-shrink-0',
        isCritical ? 'tw-text-red' : 'tw-text-orange',
      )}
    >
      <Icon
        kind={isCritical ? 'exclamationTriangleFill' : 'exclamationTriangle'}
        className="tw-icon-20 tw-shrink-0"
      />
      <span className="tw-flex-1 tw-text-left">{children}</span>
    </SettingsGroupItem>
  );
}
